module.exports = __webpack_public_path__ + "static/media/ontvangen_white.255f061a.svg";